export const reducer = (state, action) => {
    switch (action.type) {
      //case 'setUnidades':
        //return { ...state, unidades: action.payload }
      case 'setUf':
        return { ...state, uf: action.payload }
      case 'setFacturasLastUf':
        return { ...state, facturasLastUf: action.payload }
      case 'setFacturas':
        return { ...state, facturas: action.payload }

      case 'resetUnidades':
        return {
          ...state,
          //unidades: [],
          uf: '',
          facturasLastUf: null,
          facturas: []
        }
      default:
        return state
    }
  }

export const reducerPersist = (state, action) => {
    switch (action.type) {
      case 'setUnidades':
        return { ...state, unidades: action.payload }
      case 'resetUnidadesPersist':
        return {
          ...state,
          unidades: [],
        }
      default:
        return state
    }
  }
  